
export default {
    layout: 'nothing',
    data: () => ({
        title:"How it works",
        loading: true,
        dataLoaded: false,
        scrolled: false,
        window: {
            width: 0,
            height: 0
        },
        howitworks: {
          infinite: false,
          autoplay: false,
          dots: false,
          speed: 400,
          slidesToShow: 1,
          slidesToScroll: 1,
        },

    }),
    head() {
        return {
            bodyAttrs: {
                class: this.dataLoaded ? '' : 'pb-0'
            },
            title: this.title + " | Goa App",
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title + " | Goa App"
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title + " | Goa App"
          },
          {
            hid: 'description',
            name: 'description',
            content: "How it works"
          }
        ],
        }
    },


    methods: {
        start() {
            this.loading = true
            this.dataLoaded = false;
        },
        finish() {
            this.loading = false;
            this.dataLoaded = true;
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        handleScroll() {
            this.scrolled = window.scrollY > 100;
        },
    },
    created() {
        if (process.browser)
            window.addEventListener('scroll', this.handleScroll);
    },
    mounted() {
        this.$nextTick(() => {
            this.$nuxt.$loading.start();
            setTimeout(() => this.$nuxt.$loading.finish());
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        });

    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
};
